import { CaseGranulometry } from '../../CaseGranulometry';

export const isFirstCaseInProject = (caseGranulometry: CaseGranulometry) =>
  caseGranulometry.labelIndex === '1A';
